module.exports = __webpack_public_path__ + "media/brand_center/FallbackImage-850ed14b.png";